<template>
  <div>
    <Row>
      <Col span="11">
        <FormItem :label="$t( 'resourceLifecycle.name' )" prop="name">
          <Input v-model="resourceApplicationForm.name" :placeholder="$t( 'resourceLifecycle.pleaseenter' )"/>
        </FormItem>
      </Col>
      <Col span="11">
        <FormItem :label="$t( 'resourceLifecycle.addressRange' )" prop="addressRange">
          <Input v-model="resourceApplicationForm.addressRange" :placeholder="$t( 'resourceLifecycle.pleaseenter' )"/>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="24">
        <FormItem label="" style="margin-top: -10px;">
          <span>{{$t('resourceLifecycle.usingCIDRnotation')}}</span>
        </FormItem>
      </Col>
    </Row>

    <!-- 子网 -->
    <Row>
      <Col span="22">
        <Row style="margin-bottom: 10px;">
          <Col>
            <Button @click="addSubnet" style="float: right;">{{$t('resourceLifecycle.add')}}</Button>
          </Col>
        </Row>
        <FormItem :label="$t( 'resourceLifecycle.subnet' )">
          <Table :no-data-text="$t('common.noData')" :columns="subnetColumns" :data="subnetData" style="margin-bottom: 10px;">
            <template slot-scope="{row,index}" slot="delete">
              <Button type="error" size="small" @click="removeSubnet(index)">{{$t('resourceLifecycle.delete')}}</Button>
            </template>
          </Table>
        </FormItem>
      </Col>
    </Row>
  </div>
</template>

<script>
  import {setCookie,getCookie,delCookie} from '../../../../../utils/cookieUtil.js'
  export default {
    name: 'AzureVirtualNetwork',
    props: ['azureResourceApplicationBasicInfoForm'],
    components: {},
    data () {
      return {
        resourceGroupList:[],
        resourceApplicationForm: {
          name:'',
          addressRange:''
        },
        ruleValidate: {
          name: [
            {required: true, message: this.$t( 'resourceLifecycle.namecannotbeempty' ), trigger: 'blur'}
          ],
          addressRange: [
            {required: true, message: this.$t( 'resourceLifecycle.addressrangecannotbeempty' ), trigger: 'blur'}
          ]
        },
        subnetColumns: [
          {
            title: this.$t( 'resourceLifecycle.subnetName' ),
            key: 'name',
            render: (h, params) => {
              return h('Input', {
                props: {
                  value: this.subnetData[params.index].name
                },
                on: {
                  'on-blur': (event) => {
                    this.subnetData[params.index].name=event.target.value;
                  }
                }
              })
            }
          },
          {
            title: this.$t( 'resourceLifecycle.addressRange' ),
            key: 'addressSpace',
            render: (h, params) => {
              let self = this
              return h('Input', {
                props: {
                  value: this.subnetData[params.index].addressSpace
                },
                on: {
                  'on-blur': (event) => {
                    this.subnetData[params.index].addressSpace=event.target.value;
                  }
                }
              })
            }
          },
          {
            title: this.$t( 'resourceLifecycle.operations' ),
            slot: 'delete'
          }],
        subnetData: []
      }
    },
    mounted: function () {
    },
    methods: {
      showAll:function(){

      },
      /********************子网********************************/
      // 添加
      addSubnet:function(){
        this.subnetData.push({
          name: '',
          addressSpace: ''
        })
      },
      // 删除
      removeSubnet (index) {
        this.subnetData.splice(index, 1);
      }
    }
  }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_application/azure/virtual_network/AzureVirtualNetwork.vue